export default __webpack_public_path__ + "static/media/img-0207-mexico-full-face.688e66f1.png";